import React from "react";
import Checkmark from "@/components/ui/checkmark";
import { cn } from "@/utils/utils";
import { ControlProps } from "../types";

export const ChecklistItemControl: React.FC<ControlProps> = ({
  value,
  onChange,
  name,
  checkboxLabel
}) => {
  const isChecked = value === true;

  return (
    <div className="flex items-center">
      <Checkmark
        id={name}
        checked={isChecked}
        label={checkboxLabel ?? ""}
        onCheckedChange={onChange}
        className={cn(!isChecked && "border-border-secondary-button")}
        data-test={`${name}-checklist-item`}
      />
    </div>
  );
};
